<template>
  <dialog-base
    :visible.sync="visible"
    title="Lịch sử thay đổi phiếu thu"
    size="lg"
    :show-confirm="false"
    cancel-text="Đóng"
    cancel-type="danger"
    :use-panel="false"
    top="5vh"
    @cancel="handleClose"
  >
    <div class="sk-panel mb-4">
      <div class="sk-panel-head">
        <div class="sk-panel-icon sk-panel-icon--warning">
          <i class="el-icon-time" />
        </div>
        <div>
          <p class="sk-panel-title">Phiếu thu: {{ invoiceCode || '—' }}</p>
          <p class="sk-panel-subtitle">Học sinh: <strong>{{ studentName || '—' }}</strong></p>
        </div>
      </div>
    </div>

    <el-table
      v-loading="isLoading"
      :data="tableData"
      border
      style="width: 100%"
      class="sk-table mb-4"
      :empty-text="'Không có lịch sử thay đổi nào'"
    >
      <el-table-column type="index" label="STT" width="50" align="center" />
      
      <el-table-column label="Thời gian" width="160" align="center">
        <template slot-scope="{ row }">
          {{ row.modifiedDate | formatDateTime }}
        </template>
      </el-table-column>

      <el-table-column label="Người thao tác" prop="modifiedByName" min-width="150">
        <template slot-scope="{ row }">
          <span>{{ row.modifiedByName || 'Hệ thống' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Hành động" prop="actionLabel" min-width="180">
        <template slot-scope="{ row }">
          <el-tag size="small" type="info">{{ row.actionLabel || row.actionType }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="Tác vụ" width="100" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" class="sk-table-link" @click="handleViewDetail(row)">
            Chi tiết
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrapper" v-if="totalElements > 0">
      <el-pagination
        background
        :current-page.sync="page"
        :page-size.sync="size"
        :page-sizes="[10, 20, 50]"
        layout="sizes, prev, pager, next"
        :total="totalElements"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>

    <!-- Dialog chi tiết snapshot -->
    <invoice-audit-detail-dialog ref="auditDetailDialog" />
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import InvoiceAuditDetailDialog from "./InvoiceAuditDetailDialog.vue";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import moment from "moment";

export default {
  name: "InvoiceActionHistoryDialog",
  components: { DialogBase, InvoiceAuditDetailDialog },
  data() {
    return {
      visible: false,
      isLoading: false,
      invoiceCode: "",
      studentName: "",
      currentIdx: "",
      tableData: [],
      page: 1, // el-pagination uses 1-based index
      size: 10,
      totalElements: 0,
    };
  },
  filters: {
    formatDateTime(val) {
      if (!val) return "—";
      return moment(val).format("HH:mm DD/MM/YYYY");
    }
  },
  methods: {
    open(row) {
      this.invoiceCode = row.invoiceCode || "";
      this.studentName = row.fullName || "";
      this.currentIdx = row.idx;
      this.page = 1;
      this.size = 10;
      this.tableData = [];
      this.totalElements = 0;
      this.visible = true;
      if (this.currentIdx) {
        this.fetchData();
      }
    },
    async fetchData() {
      this.isLoading = true;
      try {
        const payload = {
          idx: this.currentIdx,
          page: this.page - 1, // API is 0-indexed
          size: this.size
        };
        const res = await ManagingStudentInvoiceService.getAuditHistory(payload);
        const data = res?.data?.data;
        if (data) {
          this.tableData = data.content || [];
          this.totalElements = data.totalElements || 0;
        }
      } catch (err) {
        console.error(err);
        NotifyMessage.leftCornerNotificationError("Không thể tải danh sách lịch sử thao tác");
      } finally {
        this.isLoading = false;
      }
    },
    handlePageChange(val) {
      this.page = val;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.size = val;
      this.page = 1;
      this.fetchData();
    },
    handleViewDetail(row) {
      if (row.id) {
        this.$refs.auditDetailDialog.open(row.id);
      }
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog.scss";
@import "@/assets/style/sk-table.scss";

.mb-4 {
  margin-bottom: 16px;
}
.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
</style>
